export default __webpack_public_path__ + "static/media/facebookIcon.b3801a81.svg";